import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import {
  Box,
  Container,
  DialogActions,
  DialogContent,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { makeGetRequest } from 'utils/api'
import { useSelector } from 'react-redux'
import { convertToUserDateFormate } from 'utils/helpers'
import { DataGrid } from 'Components/LifeDataGrid'
import CustomButton from 'Components/CustomButton/CustomButton'
import EditOperation from './EditOperation'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',

  borderRadius: 2,

  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function OpenAiTask({
  setShowTaskModel,
  tasklist = [],
  setTasklist,
  submitTaskList = false,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [category, setCategory] = useState([])

  const [operations, setOperations] = useState({
    results: tasklist.map((el, index) => ({ ...el, id: index + 1 })),
    count: tasklist.length,
  })

  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [selected, setSelected] = useState(false)

  const handleModelClose = () => {
    setShowTaskModel(false)
    setTasklist([])
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  const fetchCategory = async () => {
    const url = '/api/time/get-category-dd'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.name}`, id: v.id })
      })
      setCategory([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    // On fige la liste affichée (modifications/suppressions comprises) et on
    // la passe directement au callback : setTasklist est asynchrone, un
    // submitTaskList() sans argument lirait l'ancien state du parent.
    setTasklist(operations.results)
    if (submitTaskList) {
      await submitTaskList(operations.results)
    }
    setShowTaskModel(false)
  }

  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ '.ccmodel': { width: isMobile ? '90%' : '70%' } }}
      >
        <Box sx={mstyle} className="ccmodel">
          <Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {t('mesToDo.openAiGeneratedTasks')}
                  </Typography>
                  <Box>
                    <DialogContent>
                      <Container maxWidth="xl">
                        <Box justifyContent="flex-end" padding={2} display="flex">
                          <Box>
                            <CustomButton
                              sx={{ color: 'black' }}
                              onClick={() => {
                                if (selectedRows.length === 1) {
                                  setSelectedRowsParams({
                                    ...operations.results.filter(
                                      (v) => v.id === selectedRows[0],
                                    )[0],
                                  })
                                  setSelected(true)
                                } else {
                                  setSelected(false)
                                  alert(t('mesToDo.selectOneToModifyAlert'))
                                }
                              }}
                            >
                              {t('mesToDo.modify')}
                            </CustomButton>
                            {selected ? (
                              <EditOperation
                                setOperations={setOperations}
                                setSelected={setSelected}
                                params={selectedRowsParams}
                                operations={operations}
                                category={category}
                              />
                            ) : (
                              ''
                            )}

                            <CustomButton
                              sx={{ color: 'black' }}
                              onClick={() => {
                                if (selectedRows.length > 0) {
                                  let remain = operations.results.filter(
                                    (v) => selectedRows.indexOf(v.id) === -1,
                                  )
                                  setOperations({
                                    results: remain,
                                    count: remain.length,
                                  })
                                } else {
                                  alert(t('mesToDo.selectOperationAlert'))
                                }
                              }}
                            >
                              {t('mesToDo.delete')}
                            </CustomButton>
                          </Box>
                        </Box>

                        <ListOperations
                          setSelectedRows={setSelectedRows}
                          operations={operations}
                          catList={category}
                        />
                      </Container>
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} onClick={onSubmit}>
                        {t('mesToDo.validate')}
                      </Button>
                      <Button onClick={handleModelClose}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

function ListOperations({ operations, setSelectedRows, catList }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  // let navigate = useNavigate();

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'Name',
      headerName: t('mesToDo.colName'),
      width: 250,
      editable: false,
    },
    {
      field: 'Urgence',
      headerName: t('mesToDo.colPriority'),
      width: 250,
      editable: false,
    },
    {
      field: 'Date_limite',
      headerName: t('mesToDo.fieldDueDate'),
      width: 150,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.Date_limite),
    },
    {
      field: 'Cost_estime',
      headerName: t('mesToDo.fieldCosts'),
      width: 120,
      editable: false,
    },
    {
      field: 'cat_id',
      headerName: t('mesToDo.fieldCategory'),
      width: 180,
      editable: false,
      valueGetter: (params) => catList.filter((el) => el.id === params.row.cat_id)[0]?.label,
    },
  ]
  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <DataGrid
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={100}
        rowCount={operations.count ? operations.count : 0}
        rowsPerPageOptions={[100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  )
}
